import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getLoyaltyAppSettings = createSelector(appSettingsState, (appSettings) => appSettings.apiSettings);
